import Component from '../abstracts/Component';

export default class AddToCartComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-addtocart',
      actions: '.product-actions',
      cartBar: '.is-cart-bar',
      selectCustom: '.select2-selection',
      notifyMe: '.js-notify-me'
    };
  }

  get CLASSES() {
    return {
      show: 'show',
      selecting: 'cta-selectsize',
      error: 'border-error'
    };
  }

  constructor() {
    super();
    this.mainTarget = $(this.SELECTORS.main);
    this.actions = $(this.SELECTORS.actions);
  }

  sizeNotification(ev) {
    let $elem = $(ev.payload);
    let msg = $elem.attr('data-notification');
    $elem.addClass('cta-selectsize');
    $elem.find('span').length == 1 ? $elem.find('span').text(msg) : $elem.text(msg);
    let inPdp = $('.wrapper-select.pdp-select');
    let $slect2 = null;
    // se sono in pdp
    if(inPdp.length){
      $slect2 = inPdp.find(this.SELECTORS.selectCustom);
    }else{
      // sono nella wishlist page
      $slect2 = $elem.prev().find(this.SELECTORS.selectCustom)
    }
    $slect2.addClass(this.CLASSES.error);
  }

  notifyMe() {
    let inPdp = $('.wrapper-select.pdp-select');
    let $slect2 = null;
    // se sono in pdp
    if(inPdp.length){
      $slect2 = inPdp.find(this.SELECTORS.selectCustom);
    }else{
      // sono nella wishlist page
      $slect2 = $elem.prev().find(this.SELECTORS.selectCustom)
    }
    $slect2.removeClass(this.CLASSES.error);
  }

  bindEvents() {

    let ctx = this;

    //click on addtocart
    $('body').on('click.addToCart', ctx.SELECTORS.main, function (e) {
      e.preventDefault();

      let $this = $(this);
      console.log(this.dataset);
      let isBuyable = this.dataset.enabled == "true" ? true : false;

      if(this.dataset.notified == "true"){
        console.log('click after notify me');
        if($('.wrapper-select').length){
          ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.sizerequired, $this)
        }
      }else{

        if (isBuyable) {
          if (this.dataset.uniqueSize == "false" && this.dataset.selectedSize == '') {
            console.log('no size selected');
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.sizerequired, $this)
          } else {
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addtocart, {
              button: $this
            })
          }
        } else {
          if(this.dataset.notified == 'false' && $(ctx.SELECTORS.notifyMe).find('#email').val()){
            ctx.notifyMe();
          }else {
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.sizerequired, $this);
            console.log("product not available");
          }
        }

      }

    })

    this.$on(this.$customEvents.PRODUCT_EVENTS.sizerequired, (e) => {
      this.sizeNotification(e);
    });

    // hendler per evento size changed sulla select, bottoni acquista
    this.$on(this.$customEvents.PRODUCT_EVENTS.sizechanged, ({
      event,
      payload
    }) => {
      let myName = this.constructor.name;
      console.log(`%c[${myName}]%c Payload: `, 'color: #f56c42', 'color: inherit', payload);

      let $slect2 = $(this.SELECTORS.selectCustom);
      $slect2.removeClass(this.CLASSES.error);

      let addtocart = $(`${this.SELECTORS.main}[data-base-code="${payload.baseCode}"]`);

      // aggiorno tutti i bottoni acquista
      addtocart.each((i, el) => {
        el = $(el);
        el.removeClass(this.CLASSES.selecting);
        el.attr('data-code', payload.code);
        el.attr('data-notified', false);
        el.attr('data-selected-size', payload.size);

        let msg;
        if (payload.notify) {
          msg = el.attr('data-notify-label');
          el.attr('data-enabled', false);
          el.removeAttr('data-tracking-action');
        } else {
          msg = el.attr('data-addtocart-label');
          el.attr('data-enabled', true);
          el.attr('data-tracking-action', 'addToCart');
        }
        el.first().text(msg);

        console.log(`%c[${myName}]%c Shop button updated: `, 'color: #f56c42', 'color: inherit', el);
      });

      let $notifyBtn = $(`${ctx.SELECTORS.actions}:not(${ctx.SELECTORS.cartBar}) ${ctx.SELECTORS.main}`);
      if (payload.notify) {
        // taglia non disponibile, apro il form notify size
        ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.notifyme, $notifyBtn);
      } else {
        if($notifyBtn.hasClass('form-sumbmit')) ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.notifymeclose, $notifyBtn);
      }

    });

    // handler per evento aggiungi al carrelo
    this.$on(this.$customEvents.PRODUCT_EVENTS.addtocart, ({
      event,
      payload
    }) => {

      let $elem = $(payload.button);
      // console.log($elem);
      // mostro il loader
      let previusText = $elem.html();
      $elem.html('');
      this.$emit(this.$customEvents.LOADER_EVENTS.showLocal, {
        button: $elem
      })

      $elem.attr("disabled", true);

      $.ajax({
        url: $elem.attr('data-href'),
        data: $elem[0].dataset,
        dataType: "html",
        success: function (data) {
          if(data == '650'){
            var remoteHref = $elem.data('exceeded-cart-qty') + $elem.data('product-code');

            $.ajax({
              url: remoteHref,
              dataType: "html",
              success: function(html) {
                $elem.attr("disabled", false);

                ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                  unsafeContent: html,
                  modalClass: 'exceeded-cart-products'
                })

                // nascondi il loader
                ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {
                  button: $elem
                });

                // ripristina l'html precedente
                setTimeout(() => {
                  $elem.html(previusText);
                }, 1000);

                console.info("[AddToCart] Exceed product max number on cart.")
              },
              error: function(xhr) {
                $elem.attr("disabled", false);
                console.error("[AddToCart]", xhr, arguments);
              }
            });
          }else{
            $elem.attr("disabled", false);
            // quando aggiungo un prodotto al carrello lo rimuovo dalla wishlist
            //ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.removefromwishlistpage, $elem);
            ctx.$emit(ctx.$customEvents.PRODUCT_EVENTS.addedtocart, {
              button: $elem
            });
            // nascondi il loader
            ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {
              button: $elem
            });
            // ripristina l'html precedente
            setTimeout(() => {
              $elem.html(previusText);
            }, 1000);
          }
        },
        error: function (xhr) {
          ctx.$emit(ctx.$customEvents.LOADER_EVENTS.hideLocal, {
            button: $elem
          })

          if (xhr.status == '510') {
            var remoteHref = $elem.data('remote-unavailable') + $elem.data('code');

            $.ajax({
              url: remoteHref,
              dataType: "html",
              success: function(html) {
                $elem.attr("disabled", false);
                ctx.$emit(ctx.$customEvents.MODAL_EVENTS.show, {
                  unsafeContent: html,
                  modalClass: 'product-not-available'
                })
              },
              error: function(xhr) {
                $elem.attr("disabled", false);
                console.error("[AddToCart]", xhr, arguments);
              }
            });
          } else {
            $elem.attr("disabled", false);
            //ctx.error.html(xhr.responseText);
            ctx.error.html('Error in addtocart');
            console.error("[AddToCart]", xhr, arguments);
          }
        }
      });

    });

  }

  render() {
    this.bindEvents();
  }
}
